<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商销售</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择设备类型" class="select2">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="productname" label="设备类型" min-width="6%"></el-table-column>
          <el-table-column prop="jigouname" label="机构名称" min-width="6%"></el-table-column>
          <el-table-column prop="name" label="客户姓名" min-width="6%"></el-table-column>
          <el-table-column prop="phone" label="客户手机" min-width="6%"></el-table-column>
          <el-table-column prop="cardnumber" label="设备编号" min-width="6%"></el-table-column>
          <el-table-column prop="createtime" label="创建时间" min-width="6%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="6%">
            <template v-slot="scope">
              <el-button type="text" @click="clickedit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 编辑弹出框 -->
    <el-dialog title="修改" :visible.sync="editdialog" width="30%" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editFormRef" label-width="70px">
        <el-form-item label="产品类型" class="addAdminForm">
            <el-select v-model="editForm.bomsn" placeholder="请选择产品类型" class="select2">
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="客户姓名" class="addAdminForm">
          <el-input v-model="editForm.name" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="客户手机" class="addAdminForm">
          <el-input v-model="editForm.phone" placeholder="请输入客户手机"></el-input>
        </el-form-item>
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="editForm.cardnumber" placeholder="请输入保修卡号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveedit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹出框 end -->

    <!-- 添加运营商销售 start -->
    <el-tab-pane label="添加运营商销售" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="产品类型" class="addAdminForm">
            <el-select v-model="addForm.bomsn" placeholder="请选择产品类型" class="select2">
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="客户姓名" class="addAdminForm">
          <el-input v-model="addForm.name" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="客户手机" class="addAdminForm">
          <el-input v-model="addForm.phone" placeholder="请输入客户手机"></el-input>
        </el-form-item>
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="addForm.cardnumber" placeholder="请输入保修卡号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加运营商销售 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyErpDlsSales',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        bomsn: '',
        name: '',
        phone: '',
        cardnumber: ''
      },
      // 查询
      keywords: {
        bomsn: '',
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      editdialog: false,
      editForm: {
        bomsn: '',
        name: '',
        phone: '',
        cardnumber: ''
      },
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apigetproductsalesnum()
    this.apigetproductsaleslist()
  },
  methods: {
    clickedit (row) {
      this.editdialog = true
      this.editForm.id = row.id
      this.editForm.bomsn = row.bomsn
      this.editForm.name = row.name
      this.editForm.phone = row.phone
      this.editForm.cardnumber = row.cardnumber
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      if (!this.addForm.name) {
        this.$alert('请输入客户姓名', '提示')
        return
      }
      if (!this.addForm.phone) {
        this.$alert('请输入客户手机', '提示')
        return
      }
      if (!this.addForm.cardnumber) {
        this.$alert('请输入保修卡号', '提示')
        return
      }
      this.apiaddproductsales()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksaveedit () {
      if (!this.editForm.name) {
        this.$alert('请输入客户姓名', '提示')
        return
      }
      if (!this.editForm.phone) {
        this.$alert('请输入客户手机', '提示')
        return
      }
      if (!this.editForm.cardnumber) {
        this.$alert('请输入产品编号', '提示')
        return
      }
      this.apieditproductsales()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetproductsalesnum()
      this.apigetproductsaleslist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetproductsaleslist()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetproductsalesnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductsalesnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetproductsaleslist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductsaleslist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              that.dataList.push({ id: item1.Id, bomsn: item1.Bomsn, productname: item1.Productname, jigouid: item1.Jigouid, jigouname: item1.Jigouname, name: item1.Name, phone: item1.Phone, cardnumber: item1.Cardnumber, createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddproductsales: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        name: this.addForm.name,
        phone: this.addForm.phone,
        cardnumber: this.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductsales, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetproductsalesnum()
            that.apigetproductsaleslist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditproductsales: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        bomsn: this.editForm.bomsn,
        name: this.editForm.name,
        phone: this.editForm.phone,
        cardnumber: this.editForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductsales, Qs.stringify(data))
        .then(function (response) {
          that.apigetproductsaleslist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
